




















import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import DesksTable from "@/components/tables/desks-table.vue";
import MoveDesksModal from "@/components/modals/move-desks.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "desks",
    components: { MoveDesksModal, DesksTable, Page },
})
export default class Desks extends Vue {}
